import { render, staticRenderFns } from "./onlineApp_desktop.vue?vue&type=template&id=8689b7ae&scoped=true&"
import script from "./onlineApp_desktop.vue?vue&type=script&lang=js&"
export * from "./onlineApp_desktop.vue?vue&type=script&lang=js&"
import style0 from "./onlineApp_desktop.vue?vue&type=style&index=0&id=8689b7ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8689b7ae",
  null
  
)

export default component.exports